<main class="ws-main inbox-page">
  <div class="ws-head">
    <div>
      <h1 class="ws-h1">Inbox</h1>
      <p class="ws-sub">Notifications from every organization. Each one opens where it belongs; nothing moves you into another org.</p>
    </div>
    <div class="ws-actions">
      <button type="button" class="ws-btn" [disabled]="unreadCount === 0" (click)="onMarkAllRead()">
        <mat-icon aria-hidden="true">done_all</mat-icon>Mark all as read
      </button>
      <button type="button" class="ws-btn more-btn" [matMenuTriggerFor]="pageMenu" aria-label="More inbox actions">
        <mat-icon aria-hidden="true">more_vert</mat-icon>
      </button>
      <mat-menu #pageMenu="matMenu" xPosition="before">
        <button mat-menu-item type="button" *ngFor="let r of readOptions" (click)="setReadFilter(r.value)"
                [attr.aria-pressed]="readFilter === r.value">
          <mat-icon>{{ readFilter === r.value ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
          {{ r.label }} ({{ getReadCount(r.value) }})
        </button>
        <a mat-menu-item routerLink="/settings/notifications"><mat-icon>tune</mat-icon>Notification settings</a>
        <button mat-menu-item type="button" [disabled]="notifications.length === 0 || isLoading" (click)="onDeleteAll()">
          <mat-icon>delete_outline</mat-icon>Delete all
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="ws-toolbar">
    <span class="ws-seg" role="group" aria-label="Filter by type">
      <button type="button" *ngFor="let f of filterOptions" [class.on]="activeFilter === f.value"
              [attr.aria-pressed]="activeFilter === f.value" (click)="setFilter(f.value)">
        {{ f.label }}<ng-container *ngIf="loadedOnce"> {{ getFilterCount(f.value) }}</ng-container>
      </button>
    </span>
    <span class="ws-seg" role="group" aria-label="Order" *ngIf="isMultiOrg()">
      <button type="button" [class.on]="!orgLens.groupByOrg()" [attr.aria-pressed]="!orgLens.groupByOrg()" (click)="setGroupByOrg(false)">Newest first</button>
      <button type="button" [class.on]="orgLens.groupByOrg()" [attr.aria-pressed]="orgLens.groupByOrg()" (click)="setGroupByOrg(true)">By organization</button>
    </span>
  </div>

  <div class="inbox-cols">
    <div class="inbox-list">
      <section class="ws-card" *ngFor="let d of sections; trackBy: trackBySection" [attr.aria-label]="d.label">
        <div class="ws-sec">
          <bc-org-badge *ngIf="d.companyId" [companyId]="d.companyId" size="m" />
          <h2 class="ws-h2">{{ d.label }}</h2>
          <span class="ws-cap">{{ d.rows.length }} notifications</span>
        </div>
        <div *ngFor="let n of d.rows; let i = index; trackBy: trackByNotifId"
             class="ws-tr note-row" [class.unread]="!n.isRead" [class.clickable]="isClickable(n)"
             [class.deleting]="deletingIds.has(n.id)"
             [attr.role]="isClickable(n) ? 'link' : null" [attr.tabindex]="isClickable(n) ? 0 : null"
             (click)="onNotificationClick(n)" (keydown.enter)="onNotificationClick(n)">
          <bc-org-badge [companyId]="orgOf(n)" size="m" fallbackIcon="domain" />
          <mat-icon aria-hidden="true" class="kind">{{ iconOf(n) }}</mat-icon>
          <span class="text">
            <span class="title">{{ titleOf(n) }}</span>
            <span class="ws-cap detail" *ngIf="detailOf(n)">{{ detailOf(n) }}</span>
            <span class="ws-cap where-inline" *ngIf="whereOf(n) as w" [ngClass]="w.cls">{{ w.label }}</span>
          </span>
          <span class="ws-cap where" [ngClass]="whereOf(n)?.cls || ''">{{ whereOf(n)?.label }}</span>
          <span class="when">
            <span class="ws-cap time">{{ n.createdAt | date: timeFormat(n) }}</span>
            <button type="button" class="row-menu" [matMenuTriggerFor]="rowMenu" (click)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()" [attr.aria-label]="'Actions for: ' + titleOf(n)">
              <mat-icon aria-hidden="true">more_vert</mat-icon>
            </button>
            <mat-menu #rowMenu="matMenu" xPosition="before">
              <button mat-menu-item type="button" *ngIf="!n.isRead" (click)="onMarkAsRead(n, i)">
                <mat-icon>mark_email_read</mat-icon>Mark as read
              </button>
              <button mat-menu-item type="button" *ngIf="isAdmin && n.leaveRequestId != null" (click)="onViewLeave(n)"
                      bcNavLink="/hr/leave/pending" [bcNavLinkQueryParams]="{ requestId: n.leaveRequestId }">
                <mat-icon>visibility</mat-icon>View leave request
              </button>
              <button mat-menu-item type="button" [disabled]="isLoading" (click)="onDelete(n, i)">
                <mat-icon>delete_outline</mat-icon>Delete
              </button>
            </mat-menu>
          </span>
        </div>
      </section>

      <section class="ws-card" *ngIf="sections.length === 0">
        <div class="ws-empty">
          {{ !loadedOnce ? 'Loading notifications…'
             : notifications.length ? 'Nothing in the type, status or organizations you are showing.'
             : 'You are all caught up. New notifications will appear here.' }}
        </div>
      </section>
    </div>

    <aside class="ws-card inbox-side" aria-label="Unread by organization">
      <div class="ws-sec"><h2 class="ws-h2">Unread by organization</h2></div>
      <div class="ws-tr side-row" *ngFor="let o of unreadByOrg">
        <bc-org-badge [companyId]="o.id" size="m" />
        <span class="ws-ell">{{ o.name }}</span>
        <span class="ws-num count">{{ o.n }}</span>
      </div>
      <div class="ws-cap side-foot">Choose which organizations can send you emails in <a routerLink="/settings/notifications">Settings › Notifications</a>.</div>
    </aside>
  </div>
</main>
